export const FR_KEY = {
  premieres: 11,
  francais: 'french',
};

export const KEY_FR = {
  french: 'francais',
  11: 'premieres',
};
